// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\SessionInstanceResponse

import { DateTimefromYmd } from '#lib/helper/date.js';
import type { DateTime } from 'luxon';

export type SessionInstanceApiResponse = {
	sessionInstanceId: string;
	start: number;
	end: number;
	date: string;
	sessionId: string;
	areaId: string;
	conferenceUrl: string | null;
};

export type SessionInstance = {
	sessionInstanceId: string;
	start: number;
	end: number;
	date: DateTime;
	sessionId: string;
	areaId: string;
	conferenceUrl: string | null;
};

export function hydrateSessionInstance(data: SessionInstanceApiResponse): SessionInstance {
	return {
		...data,
		date: DateTimefromYmd(data.date)!,
	};
}